import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AssetMetaDataServiceConfig = {
  name: "AssetMetaData",
  annotations: []
} as ServiceConfig;